function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
}

function validateRequired(value) {
  return typeof value === "string" && value.trim().length > 0;
}

module.exports = { validateEmail, validateRequired };
